import React from 'react';
import './SkeletonPost.css';

const SkeletonPost = () => {
  return (
    <div className="skeleton-post">
      <div className="skeleton-header" />
      <div className="skeleton-media" />
      <div className="skeleton-caption" />
      <div className="skeleton-actions" />
    </div>
  );
};

export default SkeletonPost;
